<form #filterForm="ngForm">
  <div class="modal-header">
    <h5>{{title}} Filter</h5>
  </div>
  <div class="modal-body text-center">
    <div *ngIf="!formFilter" class="alert alert-danger">
      Application error. Form filter not set.
    </div>

    <div *ngIf="formFilter" class="text-left">

      <div class="mb-4">
        <label for="modeSelect" class="mx-1">Mode</label>
        <div>
          <div class="d-inline-block">
            <select *ngIf="formFilter" class="form-control" name="modeSelect" [(ngModel)]="formFilter.mode"
              (ngModelChange)="onFilterModeChanged()">
              <option *ngFor="let mode of filterModes">{{ mode }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="mb-2" *ngIf="formFilter&&(formFilter.mode!='empty'&&formFilter.mode!='not empty')">
        <label class="mx-1">Value</label>
        <fes-table-view-filter-input [filter]="formFilter" (keyUp)="filterKeyUp.next($event)"
          cssClass="form-control" name="filterValue">
        </fes-table-view-filter-input>
      </div>

    </div>

  </div>
  <div class="modal-footer text-center">
    <button class="btn btn-primary" (click)="ok()"
      [disabled]="(filter.mode==formFilter.mode)&&(filter.value==formFilter.value)">Ok</button>
    <button class="btn btn-warning" (click)="cancel()">Cancel</button>
  </div>
</form>